import React from "react";
// Import Material-UI icons
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import ElectricRickshawIcon from "@mui/icons-material/ElectricRickshaw";
import TwoWheelerIcon from "@mui/icons-material/TwoWheeler";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const OurAwesomeFeature = () => {
  return (
    <div>
      <style jsx>{`
        .learn-more-btn {
          display: inline-flex;
          align-items: center;
          background: #000000;
          color: white;
          padding: 10px 20px;
          border-radius: 25px;
          text-decoration: none;
          font-weight: 600;
          font-size: 14px;
          transition: all 0.3s ease;
          margin-top: 15px;
        }
        .learn-more-btn:hover {
          background: #098535;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(255, 72, 0, 0.3);
          color: white;
        }
        .learn-more-btn .arrow-icon {
          margin-left: 8px;
          transition: transform 0.3s ease;
        }
        .learn-more-btn:hover .arrow-icon {
          transform: translateX(3px);
        }
      `}</style>

      <div className="feature-area pt-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 mx-auto">
              <div className="site-heading text-center">
                <span className="site-title-tagline">Services</span>
                <h2 className="site-title">Our Transportation Services</h2>
                <div className="heading-divider"></div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 col-lg-3">
              <div className="feature-item wow fadeInUp" data-wow-delay=".25s">
                <div
                  className="feature-icon"
                  style={{
                    backgroundColor: "#098535",
                    borderBlockColor: "#098535",
                  }}
                >
                  <DirectionsCarIcon
                    sx={{
                      fontSize: 60,
                      color: "#098535",
                      backgroundColor: "white",
                      borderRadius: "50%",
                      padding: "10px",
                      boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                    }}
                  />
                </div>
                <div className="feature-content">
                  <h4>Cab</h4>
                  <p>
                    Experience premium comfort with our Cab service. Perfect for
                    business meetings, airport transfers, family outings, and
                    daily commutes. Air-conditioned vehicles with professional
                    drivers.
                  </p>
                  <a href="#" className="learn-more-btn">
                    Learn More
                    <ArrowForwardIcon
                      className="arrow-icon"
                      sx={{ fontSize: 16 }}
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div
                className="feature-item mt-lg-5 wow fadeInDown"
                data-wow-delay=".25s"
              >
                <div
                  className="feature-icon"
                  style={{
                    backgroundColor: "#098535",
                    borderBlockColor: "#098535",
                  }}
                >
                  <ElectricRickshawIcon
                    sx={{
                      fontSize: 60,
                      color: "#098535",
                      backgroundColor: "white",
                      borderRadius: "50%",
                      padding: "10px",
                      boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                    }}
                  />
                </div>
                <div className="feature-content">
                  <h4>Keke</h4>
                  <p>
                    Navigate through narrow streets and busy markets with our
                    Keke service. Cost-effective, eco-friendly, and perfect for
                    short-distance travel within local communities and
                    neighborhoods.
                  </p>
                  <a href="#" className="learn-more-btn">
                    Learn More
                    <ArrowForwardIcon
                      className="arrow-icon"
                      sx={{ fontSize: 16 }}
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="feature-item wow fadeInUp" data-wow-delay=".25s">
                <div
                  className="feature-icon"
                  style={{
                    backgroundColor: "#098535",
                    borderBlockColor: "#098535",
                  }}
                >
                  <TwoWheelerIcon
                    sx={{
                      fontSize: 60,
                      color: "#098535",
                      backgroundColor: "white",
                      borderRadius: "50%",
                      padding: "10px",
                      boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                    }}
                  />
                </div>
                <div className="feature-content">
                  <h4>Okada</h4>
                  <p>
                    Beat the traffic and reach your destination faster with our
                    Okada service. Ideal for quick errands, urgent appointments,
                    and navigating through congested areas efficiently.
                  </p>
                  <a href="#" className="learn-more-btn">
                    Learn More
                    <ArrowForwardIcon
                      className="arrow-icon"
                      sx={{ fontSize: 16 }}
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div
                className="feature-item mt-lg-5 wow fadeInDown"
                data-wow-delay=".25s"
              >
                <div
                  className="feature-icon"
                  style={{
                    backgroundColor: "#098535",
                    borderBlockColor: "#098535",
                  }}
                >
                  <LocalShippingIcon
                    sx={{
                      fontSize: 60,
                      color: "#098535",
                      backgroundColor: "white",
                      borderRadius: "50%",
                      padding: "10px",
                      boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                    }}
                  />
                </div>
                <div className="feature-content">
                  <h4>Logistic</h4>
                  <p>
                    Comprehensive logistics solutions for businesses and
                    individuals. Secure package delivery, document courier
                    services, and goods transportation with real-time tracking
                    and timely delivery guarantees.
                  </p>
                  <a href="#" className="learn-more-btn">
                    Learn More
                    <ArrowForwardIcon
                      className="arrow-icon"
                      sx={{ fontSize: 16 }}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurAwesomeFeature;
